import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import { BodyTextSmall, CaptionText } from "~/components/Typographies";
import { formatSecretForManualEntry } from "~settings/security/helpers/multiFactorAuth";

interface MultiFactorSecretRevealProps {
	secretBase32Encoded: string;
}

const MultiFactorSecretReveal = ({ secretBase32Encoded }: MultiFactorSecretRevealProps) => {
	const { t } = useTranslation("common");

	return (
		<Box sx={{ bgcolor: "action.hover", borderRadius: 1, p: 1.5 }}>
			<CaptionText color="text.secondary" sx={{ display: "block" }}>
				{t("preferences.security.enroll.manualEntryLabel")}
			</CaptionText>
			<BodyTextSmall sx={{ fontFamily: "monospace", letterSpacing: 1, wordBreak: "break-all" }}>
				{formatSecretForManualEntry(secretBase32Encoded)}
			</BodyTextSmall>
		</Box>
	);
};

export default MultiFactorSecretReveal;
